import type { ReactNode } from "react";
import { Box, Button, SheetContainer, Stack } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";

type UserManagementModalProps = {
  title: string;
  closeAriaLabel: string;
  onClose: () => void;
  onSave: () => void;
  saveDisabled?: boolean;
  footerExtras?: ReactNode;
  children: ReactNode;
};

export const UserManagementModal = ({
  title,
  closeAriaLabel,
  onClose,
  onSave,
  saveDisabled,
  footerExtras,
  children,
}: UserManagementModalProps) => {
  const i18n = useI18n();
  return (
    <SheetContainer
      active
      position="center"
      size={700}
      stickyHeader
      title={title}
      closeAriaLabel={closeAriaLabel}
      onCloseTrigger={onClose}
      footer={
        <Stack gap={2} mixin={{ padding: 4 }}>
          {footerExtras}
          <Stack direction="row" gap={2}>
            <Button size="large" disabled={saveDisabled} onClick={onSave}>
              {i18n.trans(t("flights_airline_portal_add_user_cta_primary"))}
            </Button>
            <Button size="large" variant="secondary" onClick={onClose}>
              {i18n.trans(t("flights_airline_portal_add_user_cta_secondary"))}
            </Button>
          </Stack>
        </Stack>
      }
    >
      <Box padding={0}>{children}</Box>
    </SheetContainer>
  );
};
